import React from 'react';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";
import { CardBody,  Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { connect } from "react-redux";

import { FL_CODE, FL_NAME } from "../../../components/i18n/formLabels";
import { PH_CODE, PH_NAME } from "../../../components/i18n/placeHolders";
import { setFilterInfo } from "../../../redux/actions/filterActions";

const HarborFilters = props => {
	const { filterInfo } = props.filterInfo
	const {register, handleSubmit, reset} = useForm({
		defaultValues:{
			code: filterInfo?.code,
			name: filterInfo?.name,
		}
	});

	const onSubmit = (data, _) => props.setFilterInfo(data)

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<CardBody className="">
				<Row>
					<Col md="3">
						<FormGroup>
							<Label>{FL_CODE}</Label>
							<Input type="text" name="code"
							       placeholder={ PH_CODE }
							       innerRef={register}
							/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label>{FL_NAME}</Label>
							<Input type="text" name="name"
							       placeholder={PH_NAME}
							       innerRef={register}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md="12" className="d-flex justify-content-center">
						<div className="float-right">
							<ButtonSearch/>
							<ButtonClean onClick={ reset }/>
						</div>
					</Col>
				</Row>
			</CardBody>
		</Form>
	)
}

const mapStateToProps = state => ({
	filterInfo: state.filter
})

const mapActionsToProps = ({
	setFilterInfo,
})

export default connect(mapStateToProps, mapActionsToProps)(HarborFilters)